import { put, call } from 'redux-saga/effects'
import { MLMRanking } from 'services/api/entities'
import { MLMRankingActionCreators } from 'app/reducers/MLMRankingRedux'

export function* getContractVersionLevelsRequest() {
  try {
    const response = yield call(MLMRanking.mlmContractVersionLevels)
    yield put(MLMRankingActionCreators.getContractVersionLevelsSuccess(response.data))
  } catch (error) {
    yield put(MLMRankingActionCreators.getContractVersionLevelsFailure(error.message))
  }
}
